import React, { Component } from 'react';
import { Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import { isDeviceKeyValid } from '../common/keyValidation';
import * as webViewerServersActions from '../store/webViewerServersSlice';
import { webViewerServersSelectors } from '../store/webViewerServersSlice';
import { showModalMessage } from '../store/modalsSlice';

import DeviceKeyInputNormalized from '../components/deviceKeyInputNormalized';
import { unwrapResult } from '@reduxjs/toolkit';

class ReactivateWebViewerServerDialog extends Component {
  initState = {
    deviceKey: ''
  };

  constructor(props) {
    super(props);
    this.handleClose = this.props.onClose;

    this.state = this.initState;

    this.onClose = this.onClose.bind(this);
    this.onKeyChanged = this.onKeyChanged.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onClose() {
    this.handleClose();
    this.setState(this.initState);
  }

  onKeyChanged(normalizedValue) {
    this.setState({ deviceKey: normalizedValue });
  }

  isSubmitButtonDisabled() {
    return !this.isCorrectDeviceKey();
  }

  isCorrectDeviceKey() {
    return isDeviceKeyValid(this.state.deviceKey.trim()) &&
      this.state.deviceKey !== this.props.deviceKey;
  }

  onSubmit() {
    const { serverId } = this.props;
    const { deviceKey } = this.state;
    this.onClose();
    this.props.reactivate({ webViewerServerId: serverId, deviceKey }).then(unwrapResult).catch(() => {
      this.props.showModalMessage("Error", this.props.error.toString())
    });
  }

  renderStatic() {
    return <React.Fragment>
      <FormGroup controlId="fcServerKey">
        <FormControl.Static>Server key <strong>{this.props.serverKey}</strong></FormControl.Static>
      </FormGroup>
      <FormGroup controlId="fcDeviceKey">
        <ControlLabel>Device key</ControlLabel>
        <DeviceKeyInputNormalized onChange={this.onKeyChanged}/>
      </FormGroup>
    </React.Fragment>
  }

  renderDeviceKeyError() {
    let message = this.state.deviceKey.length === 0 ? {
      text: "Enter device key",
      className: "text-info"
    } : (
      this.state.deviceKey === this.props.deviceKey ? {
        text: "Web viewer server is already activated with this device key",
        className: "text-danger"
      } : {
        text: "Device key is not correct",
        className: "text-danger"
      }
    );
    return <FormControl.Static className={message.className}>{message.text}</FormControl.Static>;
  }

  renderDynamic() {
    return !this.isCorrectDeviceKey() ?
      this.renderDeviceKeyError() :
      null;
  }

  render() {
    return (
      <Modal bsSize="small" show={this.props.show} onHide={this.onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>Reactivate web viewer server</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderStatic()}
          {this.renderDynamic()}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onSubmit} disabled={this.isSubmitButtonDisabled()}>
            Reactivate
          </Button>
          <Button onClick={this.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  error: webViewerServersSelectors.state(state).creatingUpdatingError,
});

const actionCreators = {
  reactivate: webViewerServersActions.reactivate,
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(ReactivateWebViewerServerDialog);



// WEBPACK FOOTER //
// ./src/containers/reactivateWebViewerServerDialog.js